import { onUnmounted } from '@vue/composition-api';
import { randomString } from '@berlin-front/common/utils';

/**
 * 貸し出し済みのランダム文字列のSet。重複貸出チェックに使用する。
 */
const lendStrings = new Set<string>();

/**
 * アプリケーション内で重複しないランダムな文字列を提供します。
 *
 * 文字列は0-9a-zA-Zで構成されます。
 */
export default () => {
  let id = randomString();
  while (lendStrings.has(id)) {
    id = randomString();
  }
  lendStrings.add(id);
  onUnmounted(() => {
    lendStrings.delete(id);
  });
  return id;
};
